import { createAsyncThunk } from '@reduxjs/toolkit';

import { AccountService } from 'api';

export const getBalance = createAsyncThunk('overview/getBalance', async () => {
	return await AccountService.getBalance();
});
